import { useState } from "react";
import { Form, Button } from "react-bootstrap";
import "../styles/Feedback.css";
import { Link, useNavigate } from "react-router-dom"; // ✅ Added useNavigate
import axios from "axios";
import { ChevronRight, ArrowLeft } from "lucide-react"; // ✅ Added ArrowLeft

function FeedBack() {
  const navigate = useNavigate(); // ✅ Initialize navigate for mobile back button
  const [rating, setRating] = useState(0);
  const [support, setSupport] = useState("");
  const [improvement, setImprovement] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const user = JSON.parse(localStorage.getItem("user"));

    if (!user) {
      alert("Please login first");
      return;
    }

    if (!rating || !support) {
      alert("Please fill all required fields");
      return;
    }

    const payload = {
      user_id: user.id,   // 🔥 IMPORTANT
      rating,
      support,
      improvement
    };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/api/feedback`,
        payload
      );

      console.log(res.data);
      alert("Feedback submitted successfully");

      // Reset form
      setRating(0);
      setSupport("");
      setImprovement("");

    } catch (error) {
      console.error(error);
      alert("Something went wrong");
    }
  };

  return (
    <>
      {/* --- ✅ DESKTOP HEADER & BREADCRUMB (Hidden on mobile) --- */}
      <div className="d-none d-lg-block">
        <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "''" }}>
          <ol className="breadcrumb d-flex align-items-center py-2 mb-0" style={{ fontSize: "14px" }}>
            <li className="breadcrumb-item d-flex align-items-center">
              <Link to="/" className="text-decoration-none text-secondary">Home</Link>
              <ChevronRight size={16} className="mx-1 text-secondary" />
            </li>
            <li className="breadcrumb-item fw-semibold" style={{ color: "#2F7A87" }}>
              Feedback
            </li>
          </ol>
        </nav>
      </div>

      {/* --- ✅ NEW MOBILE HEADER (Figma Replica) --- */}
      <div className="d-flex d-lg-none align-items-center px-3 pt-4 mb-2">
        <ArrowLeft size={24} className="text-dark me-2" onClick={() => navigate(-1)} style={{ cursor: "pointer" }} />
        <h4 className="fw-bold mb-0" style={{ color: "#111827", fontSize: "20px" }}>Submit Feedback</h4>
      </div>

      <div className="feedback-container p-3 p-lg-4">

        {/* Desktop Title */}
        <div className="d-none d-lg-flex align-items-center mb-2">
          <i className="bi bi-arrow-left me-2 back-icon" onClick={() => navigate(-1)}></i>
          <h5 className="mb-0">Submit Feedback</h5>
        </div>

        <p className="text-muted description ms-lg-4 mb-4 mobile-desc">
          Share your experience with our tender services to help us improve.
        </p>

        <Form onSubmit={handleSubmit}>

          {/* Question 1 */}
          <div className="question-block ms-lg-4">
            <p className="question-title">
              1. How satisfied are you with our services?
            </p>
            <div className="star-rating mobile-stars">
              {[1, 2, 3, 4, 5].map((star) => (
                <i
                  key={star}
                  className={`bi ${rating >= star ? "bi-star-fill" : "bi-star"}`}
                  onClick={() => setRating(star)}
                ></i>
              ))}
            </div>
          </div>

          {/* Question 2 */}
          <div className="question-block ms-lg-4">
            <p className="question-title">
              2. How would you describe our support responsiveness?
            </p>
            {/* ✅ Added feedback-radio-group class for mobile styling */}
            <div className="d-flex gap-lg-5 feedback-radio-group">
              {["Excellent", "Good", "Average", "Poor"].map((option) => (
                <div key={option} className="feedback-radio-item">
                  <Form.Check
                    type="radio"
                    id={`support-${option}`}
                    name="support"
                    label={option}
                    checked={support === option}
                    onChange={() => setSupport(option)}
                    className="custom-radio-check m-0"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Question 3 */}
          <div className="question-block ms-lg-4">
            <p className="question-title">
              3. What can we improve to serve you better?
            </p>
            <Form.Control
              as="textarea"
              rows={6}
              placeholder="Type your suggestions here..." /* ✅ Added placeholder from Figma */
              className="feedback-textarea"
              value={improvement}
              onChange={(e) => setImprovement(e.target.value)}
            />
          </div>

          {/* Submit */}
          <div className="submit-wrapper desktop-submit-wrapper">
            <Button
              type="submit"
              className="submit-btn btn-sm"
              disabled={!rating || !support}
            >
              Submit
            </Button>
          </div>

        </Form>
      </div>
    </>
  );
}

export default FeedBack;